import Locale from './Locale';
// import en_US from "./en_US"
export default Locale;
